import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { merchantReportType } from 'appConfig';

export interface merchantBalance {
    balance: number;
    loading: boolean;
    error: string | null;
}
const initialState: merchantBalance = {
    balance: 0,
    loading: false,
    error: null,
};

export const fetchMerchantBalance = createAsyncThunk('merchantBalance/fetchMerchantBalance', async (_, { getState }) => {
    const state: any = getState();
    const companyId = state.user?.defaultCompanyId;
    const response: any = await client.post('/merchant/getCustomReport', { companyId }, { reportType: merchantReportType });
    return response?.merchantBalance;
});

const merchantBalanceSlice = createSlice({
    name: 'merchantBalance',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchMerchantBalance.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchMerchantBalance.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            const { total } = action?.payload;
            state.balance = total || 0;
        });
        builder.addCase(fetchMerchantBalance.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.error?.message || null;
        });
    },
});
export default merchantBalanceSlice.reducer;
